function CheckboxLimiter() {
  const containers = document.querySelectorAll(".js-checkbox-limiter");

  if (!containers?.length) return;

  containers.forEach((container) => {
    const maxChecked = parseInt(container.dataset.maxChecked) || Infinity;
    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    const radios = container.querySelectorAll('input[type="radio"]');
    const isDimmable = container.dataset.isDimmable === "true";

    if (!checkboxes?.length && !radios?.length) return;

    if(maxChecked <= 0) return;

    function updateItemsState() {
      const checkedCheckboxes = container.querySelectorAll(
        'input[type="checkbox"]:checked'
      );
      const isLimitReached = checkedCheckboxes.length >= maxChecked;

      container.classList.toggle("limit-reached", isLimitReached);

      checkboxes.forEach((checkbox) => {
        const item = checkbox.closest(".checkbox-limiter__item");
        const itemRadio = item.querySelector('input[type="radio"]');
        const shouldDisable = isLimitReached && !checkbox.checked;

        checkbox.disabled = shouldDisable;
        if (isDimmable) {
          item.classList.toggle(
            "checkbox-limiter__item--dimmed",
            shouldDisable
          );
        }
        if (itemRadio) {
          itemRadio.disabled = shouldDisable;
          if (shouldDisable && itemRadio.checked) {
            itemRadio.checked = false;
          }
        }
      });
    }

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", updateItemsState);
    });

    if (radios?.length) {
      radios.forEach((radio) => {
        radio.addEventListener("change", updateItemsState);
      });
    }

    updateItemsState();
  });
}

function initCheckboxLimiter() {
  if (document.readyState !== "loading") {
    CheckboxLimiter();
  } else {
    document.addEventListener("DOMContentLoaded", CheckboxLimiter);
  }
}

export default initCheckboxLimiter;
